// MakeService.tsx
import { BaseService } from '../../core/BaseService';
import { PaginationParams, Wrapper } from '../../type';
import {
  ActionsTypesResponse,
  GetNotificationResponse,
  GetUnreadCountResponse,
  MarkReadUnreadRequest,
} from './interface';

export class NotificationsProfile extends BaseService {
  async getNotifications(params: PaginationParams) {
    return this.get<GetNotificationResponse>(`${this.apiUrl}/api/alerts/paged`, params);
  }

  async getUnreadCount(id: number) {
    return this.get<GetUnreadCountResponse>(`${this.apiUrl}/api/alerts/unread/count`, {
      userId: id,
    });
  }

  async markReadUnread(req: MarkReadUnreadRequest) {
    return this.put<Wrapper, MarkReadUnreadRequest>(`${this.apiUrl}/api/${req.typeName}/${req.id}`, {});
  }

  async markAllRead(req: {}) {
    return this.put<Wrapper, {}>(`${this.apiUrl}/api/alerts/readall`, req);
  }

  async getActionsType() {
    return this.get<ActionsTypesResponse>(`${this.apiUrl}/api/actions/types`);
  }
}
